import type { SocialConnection } from "@/constants";
import type { LinkedAccount } from "@/types/linked-accounts";
import { authorizedGet } from "@/utils/request";
import type { QuestState } from "@ui-kit/QuestList";
import useSWR, { type SWRConfiguration } from "swr";
import { useAccessTokenState } from "./useAccessToken";

export interface Connection extends SocialConnection {
  quest: QuestState;
  linkedAccount?: LinkedAccount;
}

export const useGetLinkedAccounts = (swrConfig?: SWRConfiguration) => {
  const accessToken = useAccessTokenState();

  return useSWR<{
    linked_accounts: LinkedAccount[];
  }>(
    accessToken ? ["/passport-profile/v1/linked-accounts", accessToken] : null,
    async ([path, token]: [string, string]) => {
      return authorizedGet(path, token);
    },
    {
      revalidateOnFocus: true,
      ...swrConfig,
    },
  );
};
